import { render } from "./DrawerSidebar.vue?vue&type=template&id=225d70f0&scoped=true"
import script from "./DrawerSidebar.vue?vue&type=script&lang=js"
export * from "./DrawerSidebar.vue?vue&type=script&lang=js"

import "./DrawerSidebar.vue?vue&type=style&index=0&id=225d70f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225d70f0"]])

export default __exports__